function ArrowBackDatePickerIcon({ size = '24', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 23"
      fill="none"
    >
      <path
        d="M15 17.75L9.07071 11.8207C9.03166 11.7817 9.03166 11.7183 9.07071 11.6793L15 5.75"
        stroke="url(#paint0_linear)"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="6"
          y1="11.75"
          x2="15.6"
          y2="16.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default ArrowBackDatePickerIcon;
